import React, {useCallback} from 'react';
import {Col, Row} from 'react-bootstrap';
import {useProductContext} from 'contexts';
import {Product} from 'components/customer/Product/entity/Product';
import {Structure} from 'components/customer/Product/entity/Structure';
import {InitialValues} from 'components/customer/Product/helpers/mapDefaults';
import DynamicImage from 'components/customer/Product/Description/DynamicImage';

interface ProductDescriptionProps {
    manufacturerDescription: string;
    inSizesTab: boolean;
    toggleManufacturerDescription: (
        state: number
    ) => (event: React.MouseEvent) => void;
    productData: Product;
    formStructure: Structure[];
    formValues: InitialValues;
}

const ProductDescription = ({
    manufacturerDescription,
    inSizesTab,
    toggleManufacturerDescription,
    productData,
    formStructure,
    formValues,
}: ProductDescriptionProps) => {
    const {getProductInfo} = useProductContext<{
        getProductInfo: (key: string) => string | number;
    }>();

    const colSpan = inSizesTab ? 4 : 2;

    const handleClick = useCallback(() => {
        toggleManufacturerDescription(
            manufacturerDescription.length > 90 ? 1 : 0
        );
    }, [toggleManufacturerDescription, manufacturerDescription]);

    const manufacturerDescriptionClassName = inSizesTab
        ? 'manufacturer-description-sizes-tab'
        : 'manufacturer-description';

    return (
        <Col md={{offset: 0, span: colSpan}} xs={{offset: 0, span: 12}}>
            {getProductInfo('image') && getProductInfo('name') ? (
                <Row>
                    <DynamicImage
                        productData={productData}
                        productConfig={formStructure}
                        inSizesTab={inSizesTab}
                        formValues={formValues}
                        manufacturerDescription={
                            manufacturerDescription ? (
                                <div className="manufacturer-description-column">
                                    <span
                                        onClick={handleClick}
                                        className={
                                            manufacturerDescription
                                                ? manufacturerDescriptionClassName
                                                : ''
                                        }>
                                        {' '}
                                        {manufacturerDescription}{' '}
                                    </span>
                                </div>
                            ) : null
                        }
                    />
                </Row>
            ) : null}
        </Col>
    );
};

export default ProductDescription;
